import { useQuery } from "@tanstack/react-query";
import { api, type ModelRef } from "./api";

export interface AgentInfo {
  id: string;
  name: string;
  icon: string;
  description: string;
  instructions: string;
  model: ModelRef | null;
  tools: string[] | null;
  skills: string[];
  builtin: boolean;
}

export const useAgents = () =>
  useQuery({
    queryKey: ["agents"],
    queryFn: () => api<{ agents: AgentInfo[] }>("/agents"),
    staleTime: 60_000,
  });

export interface ProjectInfo {
  id: string;
  name: string;
  icon: string;
  instructions: string;
  updatedAt: number;
}
export const useProjects = () =>
  useQuery({
    queryKey: ["projects"],
    queryFn: () => api<{ projects: ProjectInfo[] }>("/projects"),
  });
